import React from 'react';
import { parseQuantityValue } from '../utils/asRepairFormConfig';

const AsRepairQuantityStepper = ({
    id,
    label,
    value,
    onChange,
    disabled = false,
    required = false,
    inputRef,
    showControls = true,
}) => {
    const qty = parseQuantityValue(value);
    const inputDisplay = qty === 0 ? '' : qty;

    const apply = (next) => {
        if (next === '' || next === null || next === undefined) {
            onChange('');
            return;
        }
        const parsed = parseQuantityValue(next);
        onChange(parsed === 0 ? '' : parsed);
    };

    return (
        <div className="as-repair-add-field as-repair-qty-field-inline">
            {label ? (
                <label className="field-label" htmlFor={id}>
                    {label}
                    {required ? <span className="as-repair-required-mark"> *</span> : null}
                </label>
            ) : null}
            <div className="as-repair-quantity-stepper">
                <input
                    id={id}
                    ref={inputRef}
                    type="number"
                    className="field-input as-repair-qty-input"
                    min={0}
                    max={999999}
                    step={1}
                    value={inputDisplay}
                    onChange={(e) => apply(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    disabled={disabled}
                    inputMode="numeric"
                />
                {showControls ? (
                    <div className="as-repair-qty-controls" role="group" aria-label={label ? `${label} 수량 조절` : '수량 조절'}>
                        <button
                            type="button"
                            className="as-repair-qty-step as-repair-qty-step--plus"
                            onClick={(e) => {
                                e.stopPropagation();
                                apply(qty + 1);
                            }}
                            disabled={disabled || qty >= 999999}
                            aria-label={label ? `${label} 수량 올리기` : '수량 올리기'}
                        >
                            +
                        </button>
                        <button
                            type="button"
                            className="as-repair-qty-step as-repair-qty-step--minus"
                            onClick={(e) => {
                                e.stopPropagation();
                                apply(qty - 1);
                            }}
                            disabled={disabled || qty <= 0}
                            aria-label={label ? `${label} 수량 내리기` : '수량 내리기'}
                        >
                            −
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default AsRepairQuantityStepper;
